<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "SaMemoryToolTip",
  props: {
    identity:String,
    disable:{
      type:Boolean,
      default:false
    },
    open:{
      type:Boolean,
      default:false
    }
  },
  watch:{
    open:{
      handler(value){
        this.visible = value
      },
      immediate:true,
    }
  },
  mounted() {

  },
  computed:{
    toolTipVisible(){
      if (this.disable){
        return false
      }
      if (localStorage.getItem(this.identity)=="-1"){
        return false
      }

      return this.visible
    }
  },
  data(){
    return {
      visible:false,
    }
  },
  methods:{
    handleBtnToolTipClick(){
      this.close()
    },
    close(){
      this.visible = false
      localStorage.setItem(this.identity,"-1")
    }
  }
})
</script>

<template>
  <div>
    <a-tooltip
      placement="bottom"
      :visible="toolTipVisible"
    >
      <template slot="title">
        <div class="upload-toolTip"><div><slot name="tooltip"></slot></div> <i class="iconfont icon-icon_close icon" @click="handleBtnToolTipClick"></i></div>
      </template>
      <slot> </slot>
    </a-tooltip>
  </div>

</template>

<style scoped lang="stylus">
.upload-toolTip{
  display flex
  align-items center
  .icon{
    margin-left 13px
    font-size 8px
    cursor pointer
  }
}
</style>
